import { Star, Quote, ExternalLink } from "lucide-react";
import { useReveal } from "@/hooks/useReveal";
import { reviews, site } from "@/data/site";

export const Testimonials = () => {
  useReveal();
  return (
    <section id="bewertungen" data-testid="testimonials-section" className="py-24 md:py-32 bg-background">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-16 reveal">
          <div className="max-w-2xl">
            <p className="text-xs uppercase tracking-[0.25em] text-white/40 mb-4">
              Google-Bewertungen
            </p>
            <h2 className="font-heading font-bold text-white tracking-tight text-3xl md:text-4xl lg:text-5xl leading-tight">
              Was Kundinnen und Kunden sagen.
            </h2>
            <div className="flex items-center gap-3 mt-5">
              <span className="flex">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} className="w-5 h-5 fill-white text-white" />
                ))}
              </span>
              <span className="text-sm text-white/60">
                Ausschließlich 5-Sterne-Bewertungen bei Google
              </span>
            </div>
          </div>
          <a
            href={site.maps}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="testimonials-google-button"
            className="inline-flex items-center gap-2 rounded-full bg-white text-black px-6 py-3 text-sm font-medium hover:bg-white/85 transition-colors shrink-0"
          >
            Alle Bewertungen bei Google
            <ExternalLink className="w-4 h-4" />
          </a>
        </div>

        <div className="columns-1 md:columns-2 lg:columns-3 gap-6 [column-fill:_balance]">
          {reviews.map((r, i) => (
            <div
              key={r.name}
              data-testid={`review-card-${i}`}
              className="reveal break-inside-avoid mb-6 rounded-2xl border border-white/10 bg-card p-7 hover:border-white/25 transition-colors"
            >
              <div className="flex items-center justify-between mb-4">
                <span className="flex">
                  {[...Array(5)].map((_, s) => (
                    <Star key={s} className="w-4 h-4 fill-white text-white" />
                  ))}
                </span>
                <Quote className="w-6 h-6 text-white/15" />
              </div>
              <p className="text-sm text-white/70 leading-relaxed">{r.text}</p>
              <p className="mt-5 font-heading font-semibold text-white text-sm">
                {r.name}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
